import * as React from "react";
import HedgingSection from "./HedgingSection";
import ModelContainer from "../../../components/model/ModelContainer";
import PageTitle from "../../../components/model/PageTitle";

class Hedging extends React.Component {
    public render() {
        return <ModelContainer>
            <PageTitle/>
            <HedgingSection/>
        </ModelContainer>;
    }
}

export default Hedging;


// WEBPACK FOOTER //
// ./src/routes/Dashboard/Hedging/index.tsx